export const giftAidClaimStatus = {
  declared: 'declared',
  filed: 'filed',
  settlementSent: 'settlementSent',
  refused: 'refused',
  cancelled: 'cancelled'
} as const;

export type GiftAidClaimStatus =
  (typeof giftAidClaimStatus)[keyof typeof giftAidClaimStatus];

export const giftAidRefusalReason = {
  charityReferenceInvalid: 'charityReferenceInvalid',
  donorDetailsIncomplete: 'donorDetailsIncomplete',
  donorPostcodeNotUk: 'donorPostcodeNotUk',
  donationNotClaimable: 'donationNotClaimable',
  donorNotAccepted: 'donorNotAccepted',
  duplicateDonation: 'duplicateDonation',
  swiftaidRefused: 'swiftaidRefused'
} as const;

export type GiftAidRefusalReason =
  (typeof giftAidRefusalReason)[keyof typeof giftAidRefusalReason];

// Refusals the charity can act on get their own copy. Every other code,
// and any code core adds later, reads as the generic refusal message.
export const actionableRefusalReasons: readonly GiftAidRefusalReason[] = [
  giftAidRefusalReason.charityReferenceInvalid
];

// Set by core when an owed step did not go through (no answer, skipped, or a
// later step refused). Null when nothing is wrong. Shown beside the status,
// which stays at the latest accepted step.
export const giftAidClaimAttention = {
  awaitingSwiftaid: 'awaitingSwiftaid',
  notSent: 'notSent',
  charityNotLinked: 'charityNotLinked',
  notClaimable: 'notClaimable',
  settlementDateRefused: 'settlementDateRefused',
  cancellationRefused: 'cancellationRefused'
} as const;

export type GiftAidClaimAttention =
  (typeof giftAidClaimAttention)[keyof typeof giftAidClaimAttention];

export interface GiftAidClaim {
  amount: number | null;
  status: GiftAidClaimStatus;
  refusalReason: GiftAidRefusalReason | null;
  declaredAt: string;
  declaredAtLocal: string;
  filedAt: string | null;
  filedAtLocal: string | null;
  settlementSentAt: string | null;
  settlementSentAtLocal: string | null;
  refusedAt: string | null;
  refusedAtLocal: string | null;
  cancelledAt: string | null;
  cancelledAtLocal: string | null;
  attention?: GiftAidClaimAttention | null;
  attentionAt?: string | null;
  attentionAtLocal?: string | null;
}

export const GIFT_AID_I18N_KEY = 'donation.donation-view.gift-aid';
